import { STORE_STATUS, storeStatusLabel } from '@/lib/store-status';
import type { CatalogQualityStatus } from '../../catalog/types';

export const QUALITY_ORDER: CatalogQualityStatus[] = ['draft', 'review', 'hero', 'retired'];

export const QUALITY_LABELS: Record<CatalogQualityStatus, string> = {
    draft: STORE_STATUS.draft.label,
    review: STORE_STATUS.review.label,
    hero: STORE_STATUS.hero.label,
    retired: STORE_STATUS.retired.label,
};

export const QUALITY_HINTS: Record<CatalogQualityStatus, string> = {
    draft: 'Aún no está lista. La IA o el editor pueden rellenar copy.',
    review: 'Hay copy. Un humano revisa la vista previa antes de publicar.',
    hero: 'Ficha verificada. Es el estado que usamos como “obra maestra”.',
    retired: 'Fuera de la cola. No se trabaja salvo que se reactive.',
};

export function qualityLabel(status?: string | null): string {
    return storeStatusLabel(status);
}
